import { cx } from "@linaria/core";
import React, { RefObject } from "react";
import { AlertIcon } from "../../icons/Alert";

import * as css from "./styles";

type Props = {
  ref?: RefObject<HTMLDivElement | null>;

  isLoading: boolean;
  onRetry(): void;
};

export const Error: React.FC<Props> = ({ ref, isLoading, onRetry }) => {
  return (
    <div ref={ref} className={css.errorCls}>
      <div className={css.iconCls}>
        <AlertIcon width={150} height={150} />
      </div>
      <p className={css.textCls}>Noget gik galt!</p>
      <button className={css.buttonCls} onClick={onRetry}>
        <span className={css.buttonTextCls}>Klik her for at prøve igen</span>
        <span className={cx(css.loadingEllipsisCls, isLoading && "active")}>
          .
        </span>
      </button>
    </div>
  );
};
